<template>
  <v-menu v-model="menu" :position-x="position.x" :position-y="position.y" :close-on-content-click="false" :nudge-width="600" offset-x>
    <v-form ref="form" style="width: 100%;">
      <v-card>
        <v-card-title class="title py-1">
          <div>
            <div class="pt-1"> {{ type }} reports sent</div>
            <div class="caption py-1">
              <v-icon small>account_circle</v-icon>
              {{ recipientName }}
            </div>
          </div>
          <v-spacer />
          <v-btn class="ma-0" icon @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />
        <!-- <v-card-text class="">
          <v-text-field :loading="isSearching" class="emphasize-clear" prepend-inner-icon="search" v-model="search"
            clearable solo placeholder="Search reports" hide-details>
          </v-text-field>
        </v-card-text> -->

        <!-- Not enough reports to use this  -->
        <!-- <div class="default-border-bottom scroll-border-bottom">
          <v-item-group mandatory v-model="filterToggle" active-class="white--text">
            <v-subheader style="display: inline; cursor: default;">Show:</v-subheader>
            <v-item>
              <v-chip small slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active"
                class="clickable chipFilter" @click="toggle">Available</v-chip>
            </v-item>
            <v-item>
              <v-chip small slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active"
                class="clickable chipFilter" @click="toggle">
                <div style="float: left;" class="pr-2"
                  :class="{ 'info--text font-weight-bold': formObject.stationIds.length > 0 }">
                  {{ formObject.stationIds.length }}
                </div>
                Selected
              </v-chip>
            </v-item>
          </v-item-group>
        </div> -->
        <v-card-text>
          <v-subheader>Send reports...</v-subheader>
          <SelectReports ref="selectReports" @isSearching="issearching = $event" :search="search" :filterToggle="filterToggle" :filterToggles="filterToggles" :entity="reports" item-name="Reports" entity-description="description" entity-name="name" @selected="onSelection($event)" hide-category-icons />
          <!-- select reports -->
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />

          <v-btn color="success" outline @click="submit()">{{$t('Button.Save')}}</v-btn>
          <v-btn outline color="secondary" @click="close()">{{$t('Button.Cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-menu>
</template>

<script>
  import SelectReports from './SelectReports'

  import {
    reports,
  } from '@/helpers/discreteImportNotifications'

  const TYPES = {
    create: 'Add',
    update: 'Edit',
  }

  const filterToggles = {
    available: 0,
    selected: 1,
    unavailable: 2,
  }

  export default {
    components: {
      SelectReports,
    },
    props: {
      configuration: Object,
      position: {
        type: Object,
        default: () => ({
          x: 0,
          y: 0,
        }),
      },
    },
    data: () => ({
      reports,
      menu: false,
      recipient: null,
      filterToggles,
      search: '',
      isSearching: false,
      filterToggle: filterToggles.available,
      formObject: {},
      initialObject: {
        email: null,
        name: null,
        reportIds: [],
      },
      errorMessages: {
        guidelineStations: [],
      },
      type: TYPES.create,
      initialItem: null,
    }),
    computed: {
      rules() {
        return {
          required: (v) => !!v || 'Required',
        }
      },
      recipientName() {
        return this.initialItem && (this.initialItem.name || this.initialItem.email)
      },
    },
    methods: {
      emailIndex(v) {
        return this.configuration.recipients.findIndex(r => r.email == v)
      },
      onSelection(selection) {
        this.formObject.reportIds = selection.map(report => report.id)
      },
      submit() {
        if (!this.$refs.form.validate()) return

        if (this.type == TYPES.create) {
          this.create()
        } else if (this.type == TYPES.update) {
          this.update()
        } else {
          throw 'Unsupported type'
        }
      },
      update() {
        let recipient = JSON.parse(JSON.stringify(this.formObject))
        let recipientIndex = this.emailIndex(this.initialItem.email)

        this.configuration.recipients.splice(recipientIndex, 1, recipient)
        this.close()
      },
      create() {
        let recipient = JSON.parse(JSON.stringify(this.formObject))

        this.configuration.recipients.push(recipient)
        this.close()
      },
      show(item) {
        this.type = TYPES.create
        this.menu = true

        this.initialItem = item
        if (item) {
          this.$refs.selectReports.selectIds(item.reportIds)
          this.type = TYPES.update

          this.formObject = {
            ...this.formObject,
            ...item,
          }
        } else {
          this.reassign()
        }
      },
      close() {
        this.reassign()
        this.menu = false
      },
      reassign() {
        this.formObject = JSON.parse(JSON.stringify(this.initialObject))
      },
    },
    created() {
      this.formObject = JSON.parse(JSON.stringify(this.initialObject))
      this.reassign()
    },
  }
</script>